/* eslint-disable react/no-multi-comp */
/* eslint-env browser */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["componentDidMount"] }] */

import React, { Component } from 'react';
import Portal from 'react-portal';
import { connect } from 'react-redux';
import { modalVisible, modalHidden } from 'actions';

import Icon from 'components/common/Icon';
import Header from 'components/common/Header';

class ModalInner extends Component {
  componentDidMount() {
    window.scrollTo(0, 1);
  }

  render() {
    return (
      <div className="portal-modal">
        <Header
          content={this.props.title}
          showBack={false}
          rightAction={this.props.rightAction}
          leftAction={(
            <Icon icon="close" onClick={this.props.closePortal} />
          )}
        />
        <div style={{ paddingBottom: 50, paddingTop: 52 }}>
          {this.props.children}
        </div>
        <div className="doneBar">
          <button onClick={this.props.closePortal}>Done</button>
        </div>
      </div>
    );
  }
}

class Modal extends Component {
  render() {
    const { children, ...props } = this.props;

    return (
      <Portal
        {...props}
        onOpen={this.props.modalVisible}
        beforeClose={(node, removeFromDOM) => {
          this.props.modalHidden();
          setTimeout(() => {
            removeFromDOM();
          }, 200);
        }}
      >
        <ModalInner {...props}>
          {children}
        </ModalInner>
      </Portal>
    );
  }
}

function mapStateToProps(/* state */) {
  return { };
}

export default connect(mapStateToProps, {
  modalVisible,
  modalHidden,
})(Modal);



// WEBPACK FOOTER //
// ./src/app/components/common/Modal.js